import { useState, useEffect } from "react";
import "./Banner.css";

const slides = [
  {
    image: "/images/banner/img1.jpg",
    title: "Welcome to Techno India",
    // desc: "Building the Future of Technology"
  },
  {
    image: "/images/banner/img2.jpg",
    title: "Innovative Learning",
    // desc: "Empowering Students for Tomorrow"
  },
  {
    image: "/images/banner/img3.jpg",
    title: "Global Opportunities",
    // desc: "Creating Leaders for the World"
  }
];

export default function Hero() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hero">

      <img
        className="img prev"
        src={slides[(index - 1 + slides.length) % slides.length].image}
        alt=""
      />

      <div key={index} className="reveal">
        <img src={slides[index].image} alt="" />
      </div>

      {/* Text */}
      <div key={"text"+index} className="hero-text">
        <h1>{slides[index].title}</h1>
        <p>{slides[index].desc}</p>
      </div>

    </div>
  );
}